angular.module('charts')
    .directive('dblSorter', function() {
        return {
            restrict: 'E',
            scope: {
                dblSortDirection: '='
            },
            templateUrl: '/resources/charts/directives/sorter/dbl-sorter.directive.html',
            link: function(scope, element) {
                scope.$watch('dblSortDirection', function (newVal) {
                    var container = angular.element(element);
                    if (newVal === 1) {
                        container
                            .removeClass('descending')
                            .addClass('ascending');
                    } else if (newVal === -1) {
                        container
                            .removeClass('ascending')
                            .addClass('descending');
                    } else {
                        container
                            .removeClass('ascending')
                            .removeClass('descending');
                    }
                });
            }
        };
    });
